export type LocalizedTitles = {
  title: string;
  title_ru?: string;
  title_ua?: string;
  title_ar?: string;
};

// Same locale codes as the rest of the site (see utils/helpers languageHandler).
export const localizedTitle = (movie: LocalizedTitles, language: string) => {
  const localized =
    language === "ru"
      ? movie.title_ru
      : language === "uk"
        ? movie.title_ua
        : language === "ar"
          ? movie.title_ar
          : null;
  return localized || movie.title;
};

// Cells show a window into the baked pool. The window has to start on a metadata batch
// boundary (cell.subgrid indexes both the atlas layer and the JSON batch) and must not run
// past the end of the pool, or cells point at media that was never baked.
export const pickCellIdOffset = (
  poolCount: number,
  cells: number,
  subgridSize: number,
  random: () => number = Math.random,
) => {
  const spareBatches = Math.floor((poolCount - cells) / subgridSize);
  if (!Number.isFinite(spareBatches) || spareBatches <= 0) return 0;
  return subgridSize * Math.floor(random() * (spareBatches + 1));
};
